// frappe.Dwchat
// Author - Nihal Mittal <nihal@erpnext.com>

import {
  DwchatBubble,
  DwchatList,
  DwchatSpace,
  DwchatWelcome,
  get_settings,
  scroll_to_bottom,
} from './components';
frappe.provide('frappe.Dwchat');
frappe.provide('frappe.Dwchat.settings');

/** Spawns a dwchat widget on any web page */
frappe.Dwchat = class {
  constructor() {
    this.setup_app();
  }

  /** Create all the required elements for dwchat widget */
  create_app() {
    this.$app_element = $(document.createElement('div'));
    this.$app_element.addClass('dwchat-app');
    this.$dwchat_container = $(document.createElement('div'));
    this.$dwchat_container.addClass('dwchat-container');
    $('body').append(this.$app_element);
    this.is_open = false;

    this.$dwchat_element = $(document.createElement('div'))
      .addClass('dwchat-element')
      .hide();

    this.$dwchat_element.append(`
			<span class="dwchat-cross-button">
				${frappe.utils.icon('close', 'lg')}
			</span>
		`);
    this.$dwchat_element.append(this.$dwchat_container);
    this.$dwchat_element.appendTo(this.$app_element);

    this.dwchat_bubble = new DwchatBubble(this);
    this.dwchat_bubble.render();

    const navbar_icon_html = `
        <li class='nav-item dropdown dropdown-notifications 
          dropdown-mobile dwchat-navbar-icon' title="Show Dwchats" >
          ${frappe.utils.icon('small-message', 'md')}
          <span class="badge" id="dwchat-notification-count"></span>
        </li>
    `;

    if (this.is_desk === true) {
      $('header.navbar > .container > .navbar-collapse > ul').prepend(
        navbar_icon_html
      );
    }
    this.setup_events();
  }

  /** Load dependencies and fetch the settings */
  async setup_app() {
    try {
      const token = localStorage.getItem('guest_token') || '';
      const res = await get_settings(token);
      this.is_admin = res.is_admin;
      this.is_desk = 'desk' in frappe;

      if (res.enable_dwchat === false || (!this.is_desk && this.is_admin)) {
        return;
      }

      this.create_app();
      await frappe.socketio.init(res.socketio_port);

      frappe.Dwchat.settings = {};
      frappe.Dwchat.settings.user = res.user_settings;
      frappe.Dwchat.settings.unread_count = 0;

      if (res.is_admin) {
        // If the user is admin, render everthing
        this.dwchat_list = new DwchatList({
          $wrapper: this.$dwchat_container,
          user: res.user,
          user_email: res.user_email,
          is_admin: res.is_admin,
        });
        this.dwchat_list.render();
      } else if (res.is_verified) {
        // If the token and ip address matches, directly render the dwchat space
        this.dwchat_space = new DwchatSpace({
          $wrapper: this.$dwchat_container,
          profile: {
            room_name: res.guest_title,
            room: res.room,
            is_admin: res.is_admin,
            user: res.user,
            user_email: res.user_email,
          },
        });
      } else {
        //Render the welcome screen if the user is not verified
        this.dwchat_welcome = new DwchatWelcome({
          $wrapper: this.$dwchat_container,
          profile: {
            name: res.guest_title,
            is_admin: res.is_admin,
            dwchat_status: res.dwchat_status,
          },
        });
        this.dwchat_welcome.render();
      }
    } catch (error) {
      console.error(error);
    }
  }

  /** Shows the dwchat widget */
  show_dwchat_widget() {
    this.is_open = true;
    this.$dwchat_element.fadeIn(250);
    if (typeof this.dwchat_space !== 'undefined') {
      scroll_to_bottom(this.dwchat_space.$dwchat_space_container);
    }
  }

  /** Hides the dwchat widget */
  hide_dwchat_widget() {
    this.is_open = false;
    this.$dwchat_element.fadeOut(300);
  }

  should_close(e) {
    const dwchat_app = $('.dwchat-app');
    const navbar = $('.navbar');
    const modal = $('.modal');
    return (
      !dwchat_app.is(e.target) &&
      dwchat_app.has(e.target).length === 0 &&
      !navbar.is(e.target) &&
      navbar.has(e.target).length === 0 &&
      !modal.is(e.target) &&
      modal.has(e.target).length === 0
    );
  }

  setup_events() {
    const me = this;
    $('.dwchat-navbar-icon').on('click', function () {
      me.dwchat_bubble.change_bubble();
    });

    $(document).mouseup(function (e) {
      if (me.should_close(e) && me.is_open === true) {
        me.dwchat_bubble.change_bubble();
      }
    });
  }
};

$(function () {
  new frappe.Dwchat();
});
